// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid-module--grid--3wtAu"};